<template>
    <div>
        
        <div class="container">
            <Cabecera></Cabecera>
            <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/RegistrarFlujoEntrada">Registrar Flujo de Caseta</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <Menu/>

<div class="row">
    <div class="col s12 m12 l12">
      <div class="card">
        <div class="card-content  black-text">
          <span class="card-title">Control de Acceso a Rastro</span>
          <form id="verificarGafete" autocomplete="off" @submit.prevent="getId" enctype="multipart/form-data">
          <input type="text" placeholder="Unidad" :value="unidad" required @blur="usuario" readonly>
          <input type="text" placeholder="Gafete" name="gafete" id="gafete"  v-on:click=getIdusuario() required>
         

            <input type="submit" value="VERIFICAR" :class="boton" v-on:click=ajax()>
            </form>
        </div>
        <div class="card-action">
          
         
        </div>
      </div>
    </div>
  </div>

<div class="row"  v-if="formEditar.estatus !== 'ACEPTADO'&&formEditar.estatus !== 'INEXISTENTE'&&formEditar.estatus !== 'RECHAZADO'">
    <div class="col s12 m12 l12">
      <div class="card">
        <div class="card-content  black-text">
          <span class="card-title">Control de Acceso a Visitantes</span>
          <span class="card-title"><img :src="formEditar.foto" :alt="formEditar.foto" width="200" class="circle">{{formEditar.nombre}}</span>
          <form id="editarVisitante" autocomplete="off" @submit.prevent="editarvisitante" enctype="multipart/form-data">
          
          <input type="text" placeholder="Unidad" :value="unidad" required disabled>
          <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" :value="fechahoy"  required>
          <input type="text" placeholder="Gafete" name="gafetevisitante" id="gafetevisitante" :value="gafetevisitante" >
            <input type="submit" name="Estatus" id="Estatus" :class="boton2" value="ACEPTADO">
              <input type="text"  placeholder="Nombre"  name="nombrevisitante" id="nombrevisitante" required>
             <input type="text" placeholder="Apellidos" name="apellidosvisitante" id="apellidosvisitante" required>
              <input type="text" placeholder="Tipo"  name="tipovisitante" id="tipovisitante" required>
              <input type="hidden"  placeholder="Teléfono"  name="telefonovisitante" id="telefonovisitante" >
              <input type="text"  placeholder="Placas"  name="placasvisitante" id="placasvisitante" >
              <input type="text"  placeholder="Área"  name="areavisitante" id="areavisitante" required>
              <div class="file-field input-field">
                <div class="btn">
                <span>FOTOGRAFÍA</span>
                <input type="file" name="fotovisitante">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>  
            
            <input type="hidden" name="placas" id="placas" placeholder="Placas"  :value="formEditar.placas" >
            <input type="hidden" name="nombre" id="nombre" placeholder="Nombre" :value="formEditar.nombre" >
             <input type="hidden" name="apellidos" id="apellidos" placeholder="Apellidos" :value="formEditar.apellidos" >
              <input type="hidden" name="tipo" id="tipo" placeholder="Tipo" :value="formEditar.tipo" >
              <input type="hidden" name="telefono" id="telefono" placeholder="Teléfono" :value="formEditar.telefono" >
               <input type="hidden" name="gafete2" id="gafete2" placeholder="Gafete" :value="formEditar.gafete" >
              <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
               <input type="hidden" name="perfilForma" id="perfilForma" :value=perfilusuario>
            <input type="hidden" name="unidad" id="unidad" :value=unidad>

            

            <input type="submit" value="INGRESA" :class="boton2"  v-on:click=ajax()>
            <p> <h4>SANCIONES</h4>  
            <input type="text" name="gafetesancion" id="gafetesancion" placeholder="Gafete" :value=gafeteSancion>
            <input type="text" name="sancion" id="sancion" placeholder="Desviación" :value=sancion>
            <input type="text" name="nombresancion" id="nombresancion" placeholder="Nombre" :value=nombreSancion>
            <input type="text" name="apellidossancion" id="apellidossancion" placeholder="Apellidos" :value=apellidosSancion>
            <div class="file-field input-field">
                <div class="btn">
                <span>EVIDENCIA</span>
                <input type="file" name="foto">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>  
            </form>
        </div>
        <div class="card-action">
          <b-button variant="warning"  @click="sancionarvisitante">SANCIONAR</b-button>
           
         
        </div>
      </div>
    </div>
  </div>


  

<div class="row" v-if="formEditar.estatus === 'ACEPTADO'">
    <div class="col s12 m12 l12">
      <div class="card">
        <div class="card-content  black-text">
          <span class="card-title">Control de Acceso a Rastro</span>
          <span class="card-title"><img :src="formEditar.foto" :alt="formEditar.foto" width="200" class="circle">{{formEditar.nombre}}</span>
          <form id="editarUsuario" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
          
          <input type="text" placeholder="Unidad" :value="unidad" required disabled>
          <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" :value="formEditar.fecharegistro" disabled required>
          <input type="text" placeholder="Gafete" :value="formEditar.gafete" disabled>
            <input type="submit" name="Estatus" id="Estatus" placeholder="Estatus" v-if="formEditar.estatus === 'ACEPTADO'" :class="boton2" :value="formEditar.estatus">
            <input type="submit" name="Estatus" id="Estatus" placeholder="Estatus" v-else-if="formEditar.estatus === 'RECHAZADO'" :class="boton3" :value="formEditar.estatus" >
            <input type="submit" name="Estatus" id="Estatus" placeholder="Estatus" v-else :class="boton3" value="INEXISTENTE" >
            <input type="text"  placeholder="Nombre" :value="formEditar.nombre" disabled>
             <input type="text" placeholder="Apellidos" :value="formEditar.apellidos" disabled>
              <input type="text" placeholder="Tipo" :value="formEditar.tipo" disabled>
              <input type="text"  placeholder="Teléfono" :value="formEditar.telefono" disabled>
              <input type="text"  placeholder="Placas" :value="formEditar.placas" disabled>
              <input type="text"  placeholder="Área" :value="formEditar.area" disabled>
            
            <input type="hidden" name="area" id="area" placeholder="Área"  :value="formEditar.area" >
            <input type="hidden" name="placas" id="placas" placeholder="Placas"  :value="formEditar.placas" >
            <input type="hidden" name="nombre" id="nombre" placeholder="Nombre" :value="formEditar.nombre" >
             <input type="hidden" name="apellidos" id="apellidos" placeholder="Apellidos" :value="formEditar.apellidos" >
              <input type="hidden" name="tipo" id="tipo" placeholder="Tipo" :value="formEditar.tipo" >
              <input type="hidden" name="telefono" id="telefono" placeholder="Teléfono" :value="formEditar.telefono" >
               <input type="hidden" name="gafete2" id="gafete2" placeholder="Gafete" :value="formEditar.gafete" >
              <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
               <input type="hidden" name="perfilForma" id="perfilForma" :value=perfilusuario>
            <input type="hidden" name="unidad" id="unidad" :value=unidad>

            

            <input type="submit" value="INGRESA" :class="boton2"  v-on:click=ajax()>
            <p> <h4>SANCIONES</h4>  
            <input type="text" name="gafetesancion" id="gafetesancion" placeholder="Gafete" :value=gafeteSancion>
            <input type="text" name="sancion" id="sancion" placeholder="Desviación" :value=sancion>
            <input type="text" name="nombresancion" id="nombresancion" placeholder="Nombre" :value=nombreSancion>
            <input type="text" name="apellidossancion" id="apellidossancion" placeholder="Apellidos" :value=apellidosSancion>
            <div class="file-field input-field">
                <div class="btn">
                <span>EVIDENCIA</span>
                <input type="file" name="foto">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>  
            </form>
        </div>
        <div class="card-action">
          <b-button variant="warning"  @click="sancionar">SANCIONAR</b-button>
           
         
        </div>
      </div>
    </div>
  </div>
<b-card>
<b-card-body class="text-center">
      <b-card-title>Pantalla de inicio</b-card-title>

      <b-card-text>
       <div>
    <h5>Listado del día <input width="4" type="date" name="fechadia" id="fechadia" placeholder="Fecha" v-on:click=ajax() >
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     @on-cell-click="onCellClick"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.column.field == 'salir'">
       <b-button variant="outline-danger">Salir</b-button>
    </span>

    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      <b-button variant="primary">Go somewhere</b-button>
    </b-card-body>
  </b-card>
</div> 
    </div>
</template>

<script>

import swal from 'sweetalert'
import Swal from 'sweetalert2'
import axios from 'axios'
import Cabecera from './Cabecera'
import Menu from './Menu'
import sesion from '../mixins/sesion'
import eliminar from '../mixins/eliminar'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
    name:'RegistrarFlujoQR',
    data(){
        return{
            formEditar:{},
            pass:'',
        passC:'',
        respuesta:'',
        correo:'',
        boton:'btn blue enabled',
        boton2:'btn green btn-lg btn-block',
        boton3:'btn red btn-lg btn-block',
        usuariolocal:'',
        fotolocal:'',
        codigoUnidad:'',
        booleanCodigo:false,
        perfilCodigo:'',
        unidadCodigo:'',
        selected:null,
        unidad:'',
        sancion:'',
        nombreSancion:'',
        apellidosSancion:'',
        gafeteSancion:'',
        perfilusuario:'',
        gafetevisitante:'',
        fechahoy: new Date().toISOString().substr(0,10),
         columns:[
        {
          label:'Gafete',
          field:'gafete'
        },
        
        {
          label:'Nombre',
          field:'nombre'
        },
        {
          label:'Apellidos',
          field:'apellidos'
        },
        {
          label:'Tipo',
          field:'tipo'
        },

        {
          label:'Placas',
          field:'placas'
        },
        {
          label:'Salir',
          field:'salir'
        },
      ],
      rows:[
      ],
        }
    },
    components:{
    Cabecera,
    Menu
  },
  created(){
      this.usuario() 
      this.getId()
    },
    computed:{
      ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  
    methods:{
      sancionarvisitante(){
  

const form=document.getElementById('editarVisitante')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarSanciones.php',new FormData(form))
                .then(res=>{
                   // this.respuesta = res.data
                    if (res.data == 'success') {
                       // this.$router.push('/inicio')
                        swal('El registro fue editado')
                        //this.ajax()
                    } else {
                        swal('No se pudo registrar la sanción'+res.data)
                    }
                })

      },
      sancionar(){
     /*   
 Swal.mixin({
  input: 'text',
  confirmButtonText: 'Siguiente &rarr;',
  showCancelButton: true,
  progressSteps: ['1', '2', '3', '4']
}).queue([
  {
    title: 'Ingresa gafete',
    text: '(En caso de no haber presiona siguiente)'
  },
  'Nombre',
  'Apellidos',
  'Desviación'
]).then((result) => {
  if (result.value) {
    
    this.gafeteSancion=result.value[0]
    this.nombreSancion=result.value[1]
    this.apellidosSancion=result.value[2]
    this.sancion=result.value[3]

  

  

    const answers = JSON.stringify(result.value)
    Swal.fire({
      title: 'Sanción registrada',
      html: `
        Los datos:
        <pre><code>${answers}</code></pre>
      
      `,
      confirmButtonText: 'OK'
    })
    //se graba en tabla de sanciones
  


  }
})*/

const form=document.getElementById('editarUsuario')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarSanciones.php',new FormData(form))
                .then(res=>{
                   // this.respuesta = res.data
                    if (res.data == 'success') {
                       // this.$router.push('/inicio')
                        swal('El registro fue editado')
                        //this.ajax()
                    } else {
                        swal('No se pudo registrar la sanción'+res.data)
                    }
                })

      },
        onCellClick(params) {
         if(params.column.field=="salir"){
           const idquery=params.row.id
           
          axios.get('https://micomidasegura.mx/comidaSegura/api/crud/editarFlujoCaseta.php?id='+idquery)
                    .then(res=>{
                        //this.respuesta = res.data
                        if (res.data =='success') {
                          this.ajax()
                            swal('Se registra salida')
                        } else {
                          swal('Error al editar registro' + res.data)
                        }
                    })}
         
         
        this.ajax()
         //
   // alert (params.row.id) // params.row - row object   /// 
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  },
        ajax(){
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     
    
     const unidadquery=this.unidad
    
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getFlujoCaseta.php?unidad='+unidadquery)
      .then(response=>{
        //swal('hola'+response.data)
        this.rows=response.data
        
      })

    },
        usuario(){
        
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     //this.usuariolocal= result
     //const tok=this.usuariolocal
     //this.usuariolocal=result;
      const tok=result
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
        
        this.usuariolocal=response.data.email
        this.perfilusuario=response.data.perfil
        this.unidad=response.data.unidad


      })
      
        },
        getIdusuario(){
            
            
            const id =document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+id)
            .then(response=>{
                   
                    this.unidad = response.data.unidad
                    
                    this.usuariolocal=response.data.email
                    
                })
                   
        },
        getId(){
           
            this.$route.params.id
            //const id = document.getElementById('gafete').value
            const id = this.$route.params.id
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getIngresoData.php?id='+id)
            
                .then(response=>{
                   //swal('hola'+response.data)
                    this.formEditar = response.data
                    
                  
                })

 }, 
        editarvisitante(){
                 const id = document.getElementById('gafete').value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/verificarEstatusFlujoVisitante.php?id='+id)
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                    
                        const form=document.getElementById('editarVisitante')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarFlujoCasetaVisitante.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                       // this.$router.push('/inicio')
                       // swal('El registro fue editado')
                        this.ajax()
                    } else {
                        swal('El post no pudo ser editado')
                    }
                })
                        this.ajax()
                    } else {
                        swal('La persona o vehículo está al interior de las instalaciones')
                    }
                })




            
        },
        
        editar(){
                 const id = document.getElementById('gafete').value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/verificarEstatusFlujo.php?id='+id)
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                    
                        const form=document.getElementById('editarUsuario')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarFlujoCaseta.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                       // this.$router.push('/inicio')
                       // swal('El registro fue editado')
                        this.ajax()
                    } else {
                        swal('El post no pudo ser editado')
                    }
                })
                        this.ajax()
                    } else {
                        swal('La persona o vehículo está al interior de las instalaciones')
                    }
                })




            
        },
        ////<h5>RES: {{respuesta}}</h5>
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
    },
    mixins:[sesion,eliminar],
    
}
</script>


// WEBPACK FOOTER //
// src/components/RegistrarFlujoQR.vue